require('./aggregatorGenericView.scss');

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
const { withRouter } = require('react-router-dom');

import { OKButton } from 'components/commons/OKButton/OKButton';
import { LoadingSection } from 'commonsComponents/loadingSection';
import { EmptyState } from 'commonsComponents/emptyState';
import { ContentBox } from 'commonsComponents/contentBox';

import {
  getAggregatorDataBankWithOneTypeProduct,
  getAggregatorDataBankWithOneTypeProductV4,
} from 'selectors/aggregator';
import { getProductDetails, getTransactionsTink } from 'actions/aggregator/aggregatorData';

import { BAD_CREDENTIALS, KO } from 'constants/aggregator/statuses';
import { TEMPORARY_ERROR, AUTHENTICATION_ERROR } from 'constants/aggregator/tinkStatuses.constants';
import AggregatorTypes from 'constants/aggregator/products';

const { FormattedText, formatText } = require('core/i18n').i18n;

import { recordLink, PROC_REVIEW, PROC_ADD_ENTITY, EVENT_ERROR_ENTITY } from 'utilities/tagging';

class AggregatorGenericViewClass extends React.PureComponent {
  getHandleOnExpand = bank => {
    const { hasDetails, getProductDetails, productType, getTransactionsTink, isTinkAggregator } =
      this.props;

    if (hasDetails) {
      return id =>
        !isTinkAggregator
          ? getProductDetails(bank.get('userBankId'), productType, id, undefined, undefined, 5)
          : getTransactionsTink(productType, id, null, null, {}, '', '', 5);
    }
  };

  handleReviewClick = () => {
    recordLink(PROC_ADD_ENTITY, PROC_REVIEW, EVENT_ERROR_ENTITY);
    this.props.history.push('/myprofile/global/entities/manage');
  };

  renderEmptyState = () => {
    const { productType } = this.props;
    const primaryText = formatText('aggregator-noProductPrimaryText', [
      formatText(`aggregatorProduct-${productType}`),
    ]);
    const secondaryText = formatText('aggregator-noProductSecondaryText', [
      formatText(`aggregatorProduct-${productType}`),
    ]);
    const linkText = formatText('aggregator-toAddEntities');
    const linkUrl = '/myprofile/global/entities/add';
    const iconType = 'search-banking';
    const button = (
      <OKButton to={linkUrl} modifier="secondary">
        {linkText}
      </OKButton>
    );

    return (
      <ContentBox>
        <EmptyState
          primaryText={primaryText}
          secondaryText={secondaryText}
          iconType={iconType}
          button={button}
        />
      </ContentBox>
    );
  };

  renderAllHiddenState = () => {
    const primaryText = formatText('aggregator-noVisibleProductPrimaryText');
    const secondaryText = formatText('aggregator-noVisibleProductSecondaryText');
    const linkText = formatText('aggregator-toManageEntities');
    const linkUrl = '/myprofile/global/entities/manage';
    const iconType = 'search-banking';
    const button = (
      <OKButton to={linkUrl} modifier="secondary">
        {linkText}
      </OKButton>
    );

    return (
      <ContentBox>
        <EmptyState
          primaryText={primaryText}
          secondaryText={secondaryText}
          iconType={iconType}
          button={button}
        />
      </ContentBox>
    );
  };

  renderBySubtype = products => {
    const { getProductComponent, isTinkAggregator } = this.props;

    return getProductComponent(products, isTinkAggregator);
  };

  renderByProduct = (products, onExpand) => {
    const { getProductComponent, isTinkAggregator } = this.props;

    return products.map((p, i) =>
      React.cloneElement(getProductComponent(p, isTinkAggregator, onExpand), { key: i })
    );
  };

  renderProducts = (type, bank, onExpand) => {
    const products = bank.get('products').filter(p => p.get('visible'));

    if (AggregatorTypes.LOANSANDMORTGAGES == type || AggregatorTypes.INVESTMENTS == type) {
      return this.renderBySubtype(bank);
    } else {
      return this.renderByProduct(products, onExpand, bank);
    }
  };

  renderError = () => {
    return (
      <div className="aggregator-generic-view__bank__header__error">
        <div className="aggregator-generic-view__bank__header__error__text">
          <i className="icon-error aggregator-generic-view__bank__header__error__icon" />
          <FormattedText value="aggregatorResume-credentialsError" />
        </div>
        <div className="aggregator-generic-view__bank__header__error__button">
          <OKButton modifier="link-complementary" onClick={() => this.handleReviewClick()}>
            {formatText('aggregatorResume-credentialsReview')}
          </OKButton>
        </div>
      </div>
    );
  };

  renderBank = bank => {
    const { productType } = this.props;

    const products = bank.get('products') || { size: 0 };

    if (!products.size) return null;
    const status =
      bank.get('tinkPsd2Status') ||
      bank.get('psd2Status') ||
      bank.get('tinkStatus') ||
      bank.get('status');
    const ERROR_STATUSES = [TEMPORARY_ERROR, AUTHENTICATION_ERROR, BAD_CREDENTIALS, KO];
    const hasError = ERROR_STATUSES.includes(status);

    const visibleProducts = products.filter(p => p.get('visible'));
    const allItemsHidden = products.every(p => !p.get('visible'));

    const bankName = bank.get('name');
    const visibleProductsAmount = visibleProducts.size;
    const content = allItemsHidden
      ? this.renderAllHiddenState()
      : this.renderProducts(productType, bank, this.getHandleOnExpand(bank));

    return (
      <div className="aggregator-generic-view__bank">
        <div className="aggregator-generic-view__bank__header row">
          <div className="col-xs-10">
            <div className="aggregator-generic-view__bank__header__name">
              {bankName}
              {visibleProductsAmount ? (
                <span className="aggregator-generic-view__bank__header__size">
                  ({visibleProductsAmount})
                </span>
              ) : null}
            </div>
            {hasError && this.renderError()}
          </div>
          <div className="aggregator-generic-view__bank__header__button col-xs-2">
            {formatText('aggregatorResume-settingsButton')}
            <OKButton modifier="link-ghost" to="/myprofile/global/entities/manage">
              <i className="aggregator-generic-view__bank__header__button__icon icon icon-preferencias" />
            </OKButton>
          </div>
        </div>
        <div className="aggregator-generic-view__bank__content">{content}</div>
      </div>
    );
  };

  render() {
    const { banksProductType, isTinkAggregator } = this.props;

    if (
      !banksProductType ||
      (!isTinkAggregator && !banksProductType.size) ||
      (isTinkAggregator && banksProductType && banksProductType.length === 0)
    )
      return <LoadingSection />;

    const hasProducts = banksProductType.some(b => (b.get('products') || { size: 0 }).size);

    const mappedRenderBanks = () => banksProductType.toList().map(this.renderBank);

    return (
      <div className="aggregator-generic-view">
        {hasProducts ? mappedRenderBanks() : this.renderEmptyState()}
      </div>
    );
  }
}

AggregatorGenericViewClass.propTypes = {
  banksProductType: PropTypes.object,
  history: PropTypes.object.isRequired,
  productsByTypeTink: PropTypes.object,
  productType: PropTypes.string,
  getProductComponent: PropTypes.func,
  getProductDetails: PropTypes.func,
  hasDetails: PropTypes.bool,
  getTransactionsTink: PropTypes.func,
  isTinkAggregator: PropTypes.bool,
};

const AggregatorGenericView = connect(
  (state, props) => {
    const { productType, isTinkAggregator } = props;

    return {
      banksProductType: !isTinkAggregator
        ? getAggregatorDataBankWithOneTypeProduct(state, productType)
        : getAggregatorDataBankWithOneTypeProductV4(state, productType),
    };
  },
  {
    getProductDetails,
    getTransactionsTink,
  }
)(withRouter(AggregatorGenericViewClass));

export { AggregatorGenericView };
